module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-durbanville-white.578afdb9.svg";